export const standardFontSize  = {
    text: '1rem',
    title: '3.5rem',
    subTitle: '2rem',
    buttonText: '1rem'
}